export function mapRFQStatus(status) {
  const stages = [
    'Draft',
    'Sent',
    'Received',
    'Processing',
    'Fulfilled',
    'Cancelled',
    'Rejected',
    'Expired',
  ];
  return stages[status] || 'Unknown';
}
